export default "__VITE_ASSET__ec145d48__"